import type { PropsWithChildren, ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

interface IProps {
    title: string;
}

const ManagementCardListItem = ({ title, children }: PropsWithChildren<IProps>): ReactElement => {
    return (
        <Flex
            flexDirection="column"
            gap="4px"
            flexGrow="1"
            minWidth="0"
        >
            <Text
                fontVariant="caption"
                color={colorsPalettes.carbon["300"]}
            >
                {title}
            </Text>
            <Text
                fontVariant="subtitle1"
                color={colorsPalettes.carbon["400"]}
            >
                {children}
            </Text>
        </Flex>
    );
};

export default ManagementCardListItem;
